import { request } from "@/interface/helper";

const str = "idostation";

export const idostation = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ido/station/list" }),
    add: (data) => request({ data, method: "post", url: "/ido/station/add" }),
    detail: (data) => request({ data, method: "post", url: "/ido/station/detail" }),
    edit: (data) => request({ data, method: "post", url: "/ido/station/modify" }),
    clearRule: (data) => request({ data, method: "post", url: "/ido/station/clear" }),
    transfer: data => request({ data, method: "get", url: "/ido/station/transfer" }),
    setLangDetail: data => request({ data, method: "post", url: "/ido/station/setlangdetail" })

  },
};
